import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} کا گمنام چیٹ ہوم`,
    languageButtonLabel: `زبان`,
    languageModalTitle: `زبان منتخب کریں`,
    languageModalCloseLabel: `زبان کا مینو بند کریں`,
  },
  languageOptions: {
    'en-US': {
      label: `انگریزی (ریاست ہائے متحدہ امریکہ)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `انگریزی (کینیا)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `انگریزی (نائجیریا)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `انگریزی (سنگاپور)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `پُرتگالی (پرتگال)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `پُرتگالی (برازیل)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `جرمن (جرمنی)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `جرمن (آسٹریا)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `جرمن (سوئٹزر لینڈ)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `ہسپانوی (ہسپانیہ)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `فرانسیسی (فرانس)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `اطالوی (اٹلی)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `ڈچ (نیدر لینڈز)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `پولش (پولینڈ)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `سویڈش (سویڈن)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `ڈینش (ڈنمارک)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `فینیش (فن لینڈ)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `نارویجین (ناروے)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `آئس لینڈک (آئس لینڈ)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `جاپانی (جاپان)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `کوریائی (جنوبی کوریا)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `چینی (چین)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `کینٹونیز (ہانگ کانگ SAR چین)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `ویتنامی (ویتنام)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `تھائی (تھائی لینڈ)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `انڈونیثیائی (انڈونیشیا)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `سواحلی (کینیا)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `ہندی (بھارت)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `بنگلہ (بنگلہ دیش)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `مراٹھی (بھارت)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `تیلگو (بھارت)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `فارسی (ایران)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو (پاکستان)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی (پاکستان)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `نائجیریائی پڈگن (نائجیریا)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `روسی (روس)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `عربی (سعودی عرب)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `عربی (متحدہ عرب امارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `عربی (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `الدارجة المغربية`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `ترکی (ترکیہ)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `زبان منتخب کریں`,
    closeLabel: `زبان کا مینو بند کریں`,
  },
  languageHint: (ctx) => `بغیر اکاؤنٹ بنائے ${ctx.localesCount}+ زبانوں میں گھومیں.`,
  readPagePrompt: ({languageLabel}) => `یہ صفحہ ${languageLabel} میں پڑھیں.`,
};
